import React, { FC, Fragment, useEffect, useState } from "react";
import { ReactComponent as ReviewStarIcon } from "assets/images/common/svgs/reviewStarIcon.svg";
import { ReactComponent as LocationIconSVG } from "assets/images/common/svgs/locationIcon.svg";
import profileImg from "assets/images/common/others/minorImage.png";
import useUsers from "containers/user-management/useHooks";
import Pagination from "components/particles/table/pagination";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import { TiStarFullOutline } from "react-icons/ti";
import { UserFiltersDTO } from "utils/helpers/models/common/user-filters.dto";
import DataNotFound from "components/particles/table/data-not-found";
import { useSelector } from "react-redux";

interface Review {
  id: number;
  name: string;
  date: string;
  avatar: string;
  review: string;
  eventName?: string;
  eventLocation?: string;
  eventDate?: string;
  rating: number;
}

interface Props {
  hostId: any;
}

const Reviews: FC<Props> = ({ hostId }) => {
  const { getReviewsbyHostId } = useUsers();
  const [data, setData] = useState<Review[]>([]);
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [filters, setFilters] = useState<UserFiltersDTO>(new UserFiltersDTO());
  const [totalElements, setTotalElements] = useState<number>(0);

  const fetchReviews = () => {
    const queryparam = {
      page: filters.page - 1,
      size: 10,
    };

    getReviewsbyHostId(
      hostId,
      setData,
      queryparam,
      setFilters,
      setTotalElements
    );
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  const onPageChange = (pageInfo: { selected: number; limit: number }) => {
    const { selected: page, limit } = pageInfo;
    const updatedFilters = { ...filters, page: page + 1, size: limit };
    setFilters(updatedFilters);
    fetchReviews();
  };

  return (
    <div className="bg-white border border-mediumGrayBorder rounded-2xl p-6 my-6">
      {data.map((review: any, index: number) => (
        <div
          key={index}
          className="flex md:flex-nowrap flex-wrap justify-between gap-4 pb-4"
        >
          <div className="flex flex-col gap-1 w-full">
            <div className="flex items-center gap-3">
              <img
                src={
                  review?.user?.profilePicUrl
                    ? concatPathWithBackendUrl(
                      review?.user?.profilePicUrl?.fileDownloadUri
                    )
                    : editProfilePicUser
                }
                alt="Avatar"
                className="w-10 h-10 rounded-full object-cover"
              />
              <div>
                <h4 className="font-bold text-black text-xs">
                  {" "}
                  {`${review?.user?.firstName} ${review?.user?.lastName}`}
                </h4>
                <p className="text-[10px] text-warmGray">   {review?.createdAt
                  ? new Date(review.createdAt).toLocaleString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    hour12: true
                  }).replace(",", " -")
                  : "N/A"}</p>

              </div>
            </div>

            <p className="text-uiDarkText text-[12px] ">{review?.comment}</p>

            {review.eventName && (
              <div>
                <p className="font-medium text-xs text-uiDarkText">
                  {review.eventName}
                </p>
                <div className="flex items-center gap-1 mt-1">
                  <LocationIconSVG className="w-3 h-3" />
                  <span className="text-warmGray text-[10px]">
                    {review.eventLocation}
                  </span>
                </div>
                <p className="text-warmGray text-[10px]">{review.eventDate}</p>
              </div>
            )}
          </div>

          <div className="flex flex-col items-center">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <TiStarFullOutline
                  key={i}
                  className={`w-4 h-4 ${i < review.rating ? "text-yellow-500" : "text-gray-300"
                    }`}
                />
              ))}
              <span className="ml-2 text-uiLabelText text-xs">
                ({review.rating})
              </span>
            </div>
          </div>
        </div>
      ))}

      <Fragment>
        <DataNotFound show={!isLoading && !data.length} />
        {totalElements > 9 && ( 
          <Pagination
            count={totalElements}
            page={filters.page}
            limit={filters.size}
            onPageChange={onPageChange}
          />
        )}
      </Fragment>
    </div>
  );
};

export default Reviews;
